import { render, staticRenderFns } from "./VlNewExaminationFilter.vue?vue&type=template&id=8406c3e4&scoped=true&"
import script from "./VlNewExaminationFilter.vue?vue&type=script&lang=js&"
export * from "./VlNewExaminationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8406c3e4",
  null
  
)

export default component.exports